const slides = document.querySelectorAll('.girl-animation-slide');
const btnNext = document.querySelector('.girl-animation-btn.next');
const btnPrev = document.querySelector('.girl-animation-btn.prev');

let index = 0;

function updateButtons() {
  btnPrev.style.display = index === 0 ? 'none' : 'flex';
  btnNext.style.display = index === slides.length - 1 ? 'none' : 'flex';
}

function showSlide(i) {
  slides.forEach(s => s.classList.remove('active'));
  slides[i].classList.add('active');
  updateButtons();
}

// кнопки
btnNext.addEventListener('click', () => {
  index++;
  if (index >= slides.length) index = slides.length - 1;
  showSlide(index);
});

btnPrev.addEventListener('click', () => {
  index--;
  if (index < 0) index = 0;
  showSlide(index);
});

// свайп на мобільних
let touchStartX = 0;
let touchEndX = 0;

const sliderContainer = document.querySelector('.girl-animation-slider') || document.body;

sliderContainer.addEventListener('touchstart', e => {
  touchStartX = e.changedTouches[0].screenX;
});

sliderContainer.addEventListener('touchend', e => {
  touchEndX = e.changedTouches[0].screenX;
  handleGesture();
});

function handleGesture() {
  const swipeDistance = touchEndX - touchStartX;
  const threshold = 50; // мінімальна відстань для свайпу

  if (swipeDistance > threshold) {
    // свайп вправо — попередній слайд
    btnPrev.click();
  } else if (swipeDistance < -threshold) {
    // свайп вліво — наступний слайд
    btnNext.click();
  }
}

// старт
showSlide(index);